export default "/images/6935374b99b58e29cde60702bc118a33.avif";